<tilby-dialog-toolbar
    mat-dialog-title
    [title]="title"
    [customActions]="customActions"
></tilby-dialog-toolbar>

<ng-template #readonlyField let-label="label" let-value="value">
    <span [class]="labelClass">{{ label | translate }}</span>
    <span [class]="valueClass">{{ value || '-' }}</span>
</ng-template>

<tilby-dialog-content [showProgressBar]="sending() || loadingItems()">
    <form autocomplete="off" [formGroup]="form"
        class="tw-grid tw-grid-cols-1 sm:tw-grid-cols-6 tw-gap-x-4 tw-gap-y-4 tw-pt-2 tw-px-2"
        [class.tw-opacity-60]="sending()">

        @if (mode === 'view' && viewValues) {
            <div class="sm:tw-col-span-2 tw-flex tw-flex-col">
                <ng-container *ngTemplateOutlet="readonlyField; context: { label: 'STOCK.ADD_EDIT_MOVEMENT.OPERATOR_NAME', value: viewValues.operator }" />
            </div>

            <div class="sm:tw-col-span-2 tw-flex tw-flex-col">
                <ng-container *ngTemplateOutlet="readonlyField; context: { label: 'STOCK.ADD_EDIT_MOVEMENT.DATE_AND_TIME', value: movement['date'] | date: 'dd/MM/yyyy HH:mm' }" />
            </div>

            <div class="sm:tw-col-span-2 tw-flex tw-flex-col">
                <ng-container *ngTemplateOutlet="readonlyField; context: { label: 'STOCK.ADD_EDIT_MOVEMENT.MOVEMENT_TYPE', value: viewValues.type }" />
            </div>

            @if (movement['type'] !== 'unload') {
                <div class="sm:tw-col-span-2 tw-flex tw-flex-col">
                    <ng-container *ngTemplateOutlet="readonlyField; context: { label: 'STOCK.ADD_EDIT_MOVEMENT.SUPPLIER', value: viewValues.supplier }" />
                </div>
            }

            <div class="sm:tw-col-span-2 tw-flex tw-flex-col">
                <ng-container *ngTemplateOutlet="readonlyField; context: { label: 'STOCK.ADD_EDIT_MOVEMENT.ORDER_NUMBER', value: viewValues.supplierOrder }" />
            </div>

            @if (movement['type'] !== 'setup') {
                <div class="sm:tw-col-span-2 tw-flex tw-flex-col">
                    <ng-container *ngTemplateOutlet="readonlyField; context: { label: 'STOCK.ADD_EDIT_MOVEMENT.CAUSE', value: viewValues.cause }" />
                </div>
            }

            <div class="sm:tw-col-span-2 tw-flex tw-flex-col">
                <ng-container *ngTemplateOutlet="readonlyField; context: { label: 'STOCK.ADD_EDIT_MOVEMENT.ITEM_TYPE', value: viewValues.entryType }" />
            </div>

            <div class="sm:tw-col-span-4 tw-flex tw-flex-col">
                <ng-container *ngTemplateOutlet="readonlyField; context: { label: 'STOCK.ADD_EDIT_MOVEMENT.PRODUCT_NAME', value: viewValues.name }" />
            </div>

            @if (movement['combination_id']) {
                <div class="sm:tw-col-span-6 tw-flex tw-flex-col">
                    <ng-container *ngTemplateOutlet="readonlyField; context: { label: 'STOCK.ADD_EDIT_MOVEMENT.COMBINATION', value: viewValues.combination }" />
                </div>
            }

            @if (movement['entry_type'] !== 'raw_material') {
                <div class="sm:tw-col-span-2 tw-flex tw-flex-col">
                    <ng-container *ngTemplateOutlet="readonlyField; context: { label: 'STOCK.ADD_EDIT_MOVEMENT.BARCODE', value: viewValues.barcode }" />
                </div>
            }

            @if (movement['options_values']) {
                <div class="sm:tw-col-span-2 tw-flex tw-flex-col">
                    <ng-container *ngTemplateOutlet="readonlyField; context: { label: 'STOCK.ADD_EDIT_MOVEMENT.DETAILS', value: viewValues.optionsValues }" />
                </div>
            }

            <div class="sm:tw-col-span-2 tw-flex tw-flex-col">
                <ng-container *ngTemplateOutlet="readonlyField; context: { label: ('STOCK.ADD_EDIT_MOVEMENT.QUANTITY' | translate: { entryUnit: '' }), value: movement['quantity'] }" />
            </div>
        } @else {
            <div class="sm:tw-col-span-3 tw-flex tw-flex-col tw-justify-center tw-pb-4">
                <ng-container *ngTemplateOutlet="readonlyField; context: { label: 'STOCK.ADD_EDIT_MOVEMENT.OPERATOR_NAME', value: operatorName }" />
            </div>

            <div class="sm:tw-col-span-3">
                <tilby-datetime-picker formControlName="date" label="STOCK.ADD_EDIT_MOVEMENT.DATE_AND_TIME" />
            </div>

            <mat-form-field class="sm:tw-col-span-3">
                <mat-label translate>STOCK.ADD_EDIT_MOVEMENT.PRODUCT_NAME</mat-label>
                <input matInput formControlName="entry" [matAutocomplete]="entryAuto">
                <mat-autocomplete #entryAuto="matAutocomplete" [displayWith]="displayEntry">
                    @for (item of filteredItems(); track item.id) {
                        <mat-option [value]="item">{{ item.name }}</mat-option>
                    }
                </mat-autocomplete>
            </mat-form-field>

            @if (combinations().length) {
                <mat-form-field class="sm:tw-col-span-3">
                    <mat-label translate>STOCK.ADD_EDIT_MOVEMENT.COMBINATION</mat-label>
                    <mat-select formControlName="combination" [compareWith]="compareCombinations"
                        (selectionChange)="onCombinationChange()">
                        @for (combination of combinations(); track combination.id) {
                            <mat-option [value]="combination">{{ combination.name }}</mat-option>
                        }
                    </mat-select>
                </mat-form-field>
            }

            @if (optionsValues()) {
                <div class="sm:tw-col-span-3 tw-flex tw-flex-col tw-justify-center tw-pb-4">
                    <ng-container *ngTemplateOutlet="readonlyField; context: { label: 'STOCK.ADD_EDIT_MOVEMENT.DETAILS', value: optionsValues() }" />
                </div>
            }

            <mat-form-field class="sm:tw-col-span-3">
                <mat-label>{{ 'STOCK.ADD_EDIT_MOVEMENT.QUANTITY' | translate: { entryUnit: entryUnit() } }}</mat-label>
                <input matInput type="number" formControlName="quantity">
            </mat-form-field>
        }

        <mat-form-field class="sm:tw-col-span-6">
            <mat-label translate>STOCK.ADD_EDIT_MOVEMENT.NOTE</mat-label>
            <input matInput formControlName="notes">
        </mat-form-field>
    </form>

    @if (mode === 'production' && form.controls.entry.value) {
        <div class="tw-flex tw-flex-col tw-px-4 tw-pb-4">
            <span class="tw-text-[var(--sys-secondary-text)] tw-mb-2" translate>STOCK.ADD_EDIT_MOVEMENT.PRODUCTION_PREVIEW</span>
            @for (material of productionPreview(); track material.id) {
                <div class="tw-flex tw-gap-2">
                    <span>{{ material.quantity }}</span>
                    <span>{{ material.name }}</span>
                </div>
            }
        </div>
    }
</tilby-dialog-content>
